import type { FC } from 'react';
import React from 'react';
import { MDText } from 'i18n-react';

import { CrossIcon, GlitterIcon } from '@motorway/mw-highway-code';
import { Chip } from '@motorway/mw-highway-code/pre-alpha';

import { useAiCompanionExperimentation } from 'Services/optimizely/experimentations/useAiCompanionExperimentation';
import { useListType, useSetListType } from 'Stores/ListStore/ListStore';
import { LIST_TYPES } from 'Utilities/consts';

import texts from '../../VehicleListV2.texts.json';

import styles from './FilterBarStart.module.scss';

const LocalT = new MDText(texts);

const ActiveLabel = (
	<span className={styles.aiCompanionLabel}>
		{LocalT.translate('aiCompanionChip.label')}
		<CrossIcon aria-hidden size="small" />
	</span>
);

export const AiCompanionChip: FC = () => {
	const isEnabled = useAiCompanionExperimentation();
	const listType = useListType();
	const setListType = useSetListType();
	const isActive = listType === LIST_TYPES.aiCompanion;

	if (!isEnabled) return null;

	return (
		<div className={isActive ? undefined : styles.iconOnlyChip}>
			<Chip
				aria-label={isActive ? undefined : `${LocalT.translate('aiCompanionChip.label')}`}
				data-testid="filter-chip-ai-companion"
				filled={isActive}
				icon={GlitterIcon}
				label={isActive ? ActiveLabel : ''}
				onClick={() => setListType(isActive ? LIST_TYPES.auction : LIST_TYPES.aiCompanion)}
				reverse={isActive}
				selected={isActive}
				size="medium"
			/>
		</div>
	);
};
